














import { Component, Vue, Prop } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { Action, Mutation } from 'vuex-class'
import { saveToLocalStorage } from '@/utils/gamblingHelpers'

@Component({
  computed: {
    ...mapState({
      isAuthenticated: ({ gamblingContext }: any) => gamblingContext.isAuthenticated,
      pageLayoutOptions: ({ gamblingContext }: any) => gamblingContext.pageLayoutOptions,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout
    })
  }
})
export default class SelectLayout extends Vue {
  @Mutation('setPageLayout') setPageLayout: any

  pageLayout!: string

  get getSetPageLayout () {
    return this.pageLayout
  }
  set getSetPageLayout (layout: string) {
    this.setPageLayout(layout)
    this.saveToLocalStorage(layout)
  }

  saveToLocalStorage (layout: string) {
    saveToLocalStorage({
      demoThemesOptions: {
        pageLayout: layout
      }
    })
  }
}
